import { render, staticRenderFns } from "./McaCurrentSpectrum3D.vue?vue&type=template&id=0a2ef2ce&scoped=true"
import script from "./McaCurrentSpectrum3D.vue?vue&type=script&lang=ts"
export * from "./McaCurrentSpectrum3D.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ef2ce",
  null
  
)

export default component.exports